import { ArrowDown, FileText, Check } from "lucide-react";

const f = (lang) => (lang === "ar" ? "font-arabic" : "font-outfit");

function SamplePreview({ lang, testId }) {
  const ar = lang === "ar";
  const rows = ar
    ? [["مقدّم العرض", "سارة أحمد — مصممة"], ["العميل", "مقهى نخبة"], ["الخدمة", "هوية بصرية"], ["المدة", "١٠ أيام عمل · ٣ تعديلات"]]
    : [["From", "Sara Ahmed — Designer"], ["Client", "Nokhba Café"], ["Service", "Brand identity"], ["Timeline", "10 working days · 3 revisions"]];
  return (
    <div data-testid={testId} dir={ar ? "rtl" : "ltr"} className={`relative rounded-2xl bg-white text-[#0f172a] p-4 shadow-[0_24px_48px_-20px_rgba(0,0,0,0.6)] rotate-[-1.5deg] ${f(lang)}`}>
      <span className="absolute -top-2.5 start-4 rounded-full bg-[#f97316] text-white text-[10px] font-bold px-2 py-0.5">
        {ar ? "نموذج ببيانات تجريبية" : "Sample with demo data"}
      </span>
      <div className="flex items-start justify-between border-b-[3px] border-[#18c98f] pb-2">
        <div className="text-lg font-bold">{ar ? "عرض سعر" : "Price Proposal"}</div>
        <div className="text-[10px] text-slate-500 text-end font-mono-num">PL-8K2Q1A<br />{ar ? "صالح ١٤ يومًا" : "Valid 14 days"}</div>
      </div>
      <dl className="mt-2 grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 text-[11px]">
        {rows.flatMap(([k, v]) => [<dt key={`${k}-k`} className="text-slate-500">{k}</dt>, <dd key={`${k}-v`} className="font-semibold">{v}</dd>])}
      </dl>
      <div className="mt-2 flex items-center justify-between rounded-lg bg-[#ecfdf5] border-b-2 border-[#18c98f] px-2.5 py-1.5 text-[12px] font-bold">
        <span>{ar ? "الإجمالي" : "Total"}</span><span className="font-mono-num" dir="ltr">2,400 {ar ? "ر.س" : "SAR"}</span>
      </div>
      <div className="mt-2 grid grid-cols-2 gap-2 text-[10px] text-slate-500">
        <div className="border-b border-dashed border-slate-400 pb-3">{ar ? "توقيع المستقل" : "Freelancer signature"}</div>
        <div className="border-b border-dashed border-slate-400 pb-3">{ar ? "توقيع العميل" : "Client signature"}</div>
      </div>
    </div>
  );
}

export default function HeroIntro({ lang, dark, onStart }) {
  const ar = lang === "ar";
  const perks = ar
    ? ["احسب السعر بالريال حسب خبرتك وحجم العمل", "عدّل بنود العرض: التسليمات والمدة والدفع", "حمّله PDF جاهزًا للإرسال والتوقيع"]
    : ["Price it in SAR from your experience and scope", "Edit deliverables, timeline and payment terms", "Download a PDF ready to send and sign"];
  return (
    <div className={`mt-5 grid gap-6 lg:grid-cols-12 items-start ${f(lang)}`}>
      <div className="lg:col-span-7 space-y-4">
        <div data-testid="hero-free-badge" className="inline-flex items-center gap-1.5 rounded-full border border-[#18c98f]/50 bg-[#18c98f]/10 px-3 py-1 text-[12px] font-bold text-[#18c98f]">
          <Check className="h-3.5 w-3.5" strokeWidth={3} />
          {ar ? "٣ حسابات مجانية شهريًا · تحميل عرض السعر مجانًا" : "3 free calculations a month · free proposal download"}
        </div>
        <button data-testid="hero-start-cta" type="button" onClick={onStart}
          className="group w-full sm:w-auto inline-flex items-center justify-center gap-2 h-14 px-8 rounded-[14px] bg-[#18c98f] text-white text-[17px] font-black shadow-[0_5px_0_0_#0e8a62,0_18px_36px_-14px_rgba(24,201,143,0.7)] hover:brightness-110 active:translate-y-[3px] active:shadow-[0_2px_0_0_#0e8a62] transition-[filter,transform,box-shadow]">
          {ar ? "ابدأ تسعير مشروعي" : "Start pricing my project"}
          <ArrowDown className="h-5 w-5 transition-transform group-hover:translate-y-0.5" strokeWidth={2.6} />
        </button>
        <ul className={`space-y-1 text-[13px] ${dark ? "text-white/75" : "text-[#2d2c35]/80"}`}>
          {perks.map((p, i) => (
            <li key={p} className="flex items-center gap-2">
              <span className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#18c98f]/15 text-[#18c98f] text-[11px] font-black font-mono-num">{i + 1}</span>{p}
            </li>
          ))}
        </ul>
        <details className="lg:hidden">
          <summary data-testid="hero-sample-toggle" className="cursor-pointer inline-flex items-center gap-1.5 text-[12px] font-bold text-[#18c98f]">
            <FileText className="h-4 w-4" /> {ar ? "شاهد نموذج عرض السعر" : "See a sample proposal"}
          </summary>
          <div className="mt-4 max-w-sm"><SamplePreview lang={lang} testId="hero-sample-proposal-mobile" /></div>
        </details>
      </div>
      <div className="hidden lg:block lg:col-span-5 lg:ps-6 pt-2"><SamplePreview lang={lang} testId="hero-sample-proposal" /></div>
    </div>
  );
}
